import React from "react";
export function LaundryNote({room}) {
  if (room?.state !== "laundry") return null;
  const parts = (room.laundry_ready_by || "").split(":");
  const hour = Number(parts[0]);
  const time = parts.length === 2 ? `${hour % 12 || 12}${parts[1] === "00" ? "" : `:${parts[1]}`} ${hour < 12 ? "am" : "pm"}` : "";
  return <div className="journey-laundry-note"><strong><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true"><path d="M3 8h18l-2 12H5L3 8ZM7 8l3-5m7 5-3-5M8 12v4m4-4v4m4-4v4"/></svg>Laundering</strong>{room.laundry_priority && <span>Priority {room.laundry_priority}</span>}{time && <span>Ready by {time}</span>}</div>;
}
